import React, { useRef, useState } from "react";
import { Button, DatePicker, Input, Space, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { PrintHeader } from "../tools/PrintHeader";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import docx from "html-docx-js/dist/html-docx";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";
import { PrintHead } from "../tools/printModal/PrintHead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";

const SearchHeader = ({ handleSearch, placeholder }) => {
  return (
    <>
      <div className="card-title">
        <Input
          size="large"
          allowClear
          prefix={<SearchOutlined style={{ color: "#a1a5b7" }} />}
          placeholder={placeholder || "Rechercher..."}
          onChange={handleSearch}
          className="min-w-150px w-lg-500px w-sm-300px"
        />
      </div>
    </>
  );
};

const ExportHeader = ({
  contentComponent,
  codeSommaire,
  title,
  exelData,
  isLandscape,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const componentRef = useRef();

  // const handlePrint = useReactToPrint({
  //     content: () => componentRef.current,
  //     // header: () => <PrintHeader title={"WP ACCEPTATION DE LA MISSION - CRITERES RELATIFS A L’ENTITE"} />,
  // });

  const exportToWord = () => {
    const el = document.getElementById("print-content");
    if (!el) return;

    const title = "EGOU EXPERT - Equipe de mission";
    const content = el.innerHTML;

    const fullContent = `
      <html xmlns:o='urn:schemas-microsoft-com:office:office'
            xmlns:w='urn:schemas-microsoft-com:office:word'
            xmlns='http://www.w3.org/TR/REC-html40'>
      <head>
        <meta http-equiv="Content-Type" content="text/html;charset=UTF-8"/>
        <title>${title}</title>
        <style>
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #000; padding: 5px; }
        </style>
      </head>
      <body>
        ${content}
      </body>
      </html>
    `;

    try {
      //const blob = docx.asBlob(fullContent);
      const blob = new Blob([fullContent], { type: "application/msword" });
      fileSaver.saveAs(blob, `EGOU EXPERT - Equipe de mission.docx`);
    } catch (error) {
      console.error("❌ Erreur lors de la conversion en fichier Word :", error);
    }
  };

  const pageStyle = `
    .page-footer, .page-footer-space {
        height: auto;
        display:block;
        margin-top:"100px";
      }
      
      .page-footer {
        position: absolute;
        bottom: 0;
        // display:block;
        width: 100%;
        border-top: 1px solid black; /* for demo */
        background: yellow; /* for demo */
        opacity:0.3;
        
      }

      .page {
        page-break-after: always;
      }
      @page {
        size: A4;
        margin: 12mm;
        margin-top: 20mm;
        margin-bottom: 18mm;

        @bottom-right {
          content: "Page " counter(page) " / " counter(pages);
        }
      }
      /* @page {
        margin-bottom: 60mm;
        size: ${isLandscape ? "landscape" : "portrait"}
      } */
    `;

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    let allRows = [];

    contentComponent.forEach((item, index) => {
      const rows = [
        [`Mission : ${item.mission} - ${item.annee}`],
        [`Client : ${item.client?.sigle}`],
        [
          `Statut : ${
            !item?.isCloture
              ? item?.lettre_mission === 0
                ? "En attente"
                : "En cours"
              : "Clôturé"
          }`,
        ],
        [], // ligne vide
        ["Nom & Prénom", "Téléphone", "Email", "Rôle"], // entête
        ...item.equipes.map((eq) => [
          `${eq.nom_user} ${eq.prenom_user}`,
          eq.telephone1_user,
          eq.email_user,
          eq.libelle_role,
        ]),
        [],
        [],
        [], // espace entre chaque mission
      ];

      allRows = [...allRows, ...rows];
    });

    const ws = XLSX.utils.aoa_to_sheet(allRows);

    // définir largeur des colonnes
    ws["!cols"] = [
      { wch: 50 }, // Nom & Prénom
      { wch: 15 }, // Téléphone
      { wch: 30 }, // Email
      { wch: 25 }, // Rôle
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Toutes_les_missions");

    XLSX.writeFile(wb, "EGOU EXPERT - Equipe de mission.xlsx");
  };

  const toggleMenu = (e) => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <Tooltip title="Exportation du traitement">
        <div className="d-flex flex-column align-items-center">
          <Button
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
            type="primary"
            icon={<FontAwesomeIcon icon={faUpload} />}
            onClick={toggleMenu}
          >
            Exporter
          </Button>
          {isMenuOpen && (
            <>
              <div
                id="kt_users_lists_views_export_menu"
                className="menu menu-sub menu-sub-dropdown menu-option menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4 show"
                data-kt-menu="true"
                data-popper-placement="bottom-end"
              >
                <div className="menu-item px-3">
                  <ReactToPrint
                    trigger={() => (
                      <a className="menu-link px-3" data-kt-users-export="pdf">
                        Exporter sous PDF
                      </a>
                    )}
                    content={() => componentRef.current}
                    documentTitle="EGOU EXPERT - Equipe de mission"
                    pageStyle={pageStyle}
                  />
                </div>
                <div className="menu-item px-3">
                  <a
                    className="menu-link px-3"
                    data-kt-users-export="word"
                    onClick={(e) => {
                      e.preventDefault();
                      exportToWord();
                    }}
                  >
                    Exporter sous Word
                  </a>
                </div>

                <div className="menu-item px-3">
                  <a
                    className="menu-link px-3"
                    data-kt-users-export="excel"
                    onClick={(e) => {
                      e.preventDefault();
                      handleExportExcel();
                    }}
                  >
                    Exporter sous Excel
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      </Tooltip>
      <div className="d-none">
        <div ref={componentRef} className="print-content" id="print-content">
          <div style={{ marginTop: "20px" }}>
            <h2 className="mb-5 text-center">Liste des Équipes de Mission</h2>

            {contentComponent.map((item) => {
              return (
                <div key={item.id}>
                  <p>
                    <strong>Mission :</strong> {item.mission} - {item.annee}{" "}
                    <br />
                    <strong>Client :</strong> {item.client?.sigle}
                    {" - "}
                    <em>{item.client?.denomination}</em>
                    <br />
                    <strong>Statut :</strong>{" "}
                    {!item?.isCloture
                      ? item?.lettre_mission === 0
                        ? "En attente"
                        : "En cours"
                      : "Clôturé"}
                  </p>
                  <table
                    border="1"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginTop: "15px",
                      marginBottom: "30px",
                    }}
                  >
                    <thead>
                      <tr>
                        <th>NOM & PRENOM</th>
                        <th>CONTACT</th>
                        <th>EMAIL</th>
                        <th>ROLE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.equipes.map((eq) => (
                        <tr key={eq.id}>
                          <td>
                            {eq.nom_user} {eq.prenom_user}
                          </td>
                          <td>{eq.telephone1_user}</td>
                          <td>{eq.email_user}</td>
                          <td>{eq.libelle_role}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <br />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

const DatePickerHeader = ({ handleDateChange }) => {
  const { RangePicker } = DatePicker;

  return (
    <>
      <Space direction="vertical" size={12}>
        <RangePicker onChange={handleDateChange} />
      </Space>
    </>
  );
};

export { SearchHeader, ExportHeader, DatePickerHeader };
